import { OPERATOR_SELECT_TYPES } from '@constants';

export const mergeAndDedup = (existing = [], incoming = []) => {
  const seen = new Set(existing.map((item) => item.id));
  return [...existing, ...incoming.filter((item) => !seen.has(item.id))];
};

export const syncFromZero = (cachedSelections, setSelections, setSelectTypes) => {
  const zeroSelections = cachedSelections[0] || [];

  [1, 2].forEach((type) => {
    const matching = zeroSelections.filter((item) => item.operatorTypeId === type);
    const current = cachedSelections[type] || [];

    if (JSON.stringify(matching) !== JSON.stringify(current)) {
      setSelections((prev) => ({
        ...prev,
        [type]: matching
      }));
      setSelectTypes((prev) => ({
        ...prev,
        [type]: OPERATOR_SELECT_TYPES.MANUAL
      }));
    }
  });
};

export const syncIntoZero = (cachedSelections, setSelections, setSelectTypes, fromType) => {
  const current = cachedSelections[fromType] || [];
  const zero = cachedSelections[0] || [];
  const merged = mergeAndDedup(zero, current);

  if (JSON.stringify(merged) !== JSON.stringify(zero)) {
    setSelections((prev) => ({
      ...prev,
      0: merged
    }));
    setSelectTypes((prev) => ({
      ...prev,
      0: OPERATOR_SELECT_TYPES.MANUAL
    }));
  }
};
